export const WAS_IMPERSONATED = 'WAS_IMPERSONATED';
